export const calculateWorkDuration = (startDate) => {
  if (!startDate) return null;

  const start = new Date(startDate);
  const now = new Date();

  if (isNaN(start.getTime())) return null;

  let yearDiff = now.getFullYear() - start.getFullYear();
  let monthDiff = now.getMonth() - start.getMonth();

  let totalMonths = yearDiff * 12 + monthDiff;

  if (now.getDate() >= start.getDate()) {
    totalMonths += 1;
  }

  return Math.max(0, totalMonths);
};

export const formatDate = (date, language = "en") => {
  if (!date) return "";

  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) return "";

  const monthNames = {
    en: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    ar: [
      "يناير",
      "فبراير",
      "مارس",
      "أبريل",
      "مايو",
      "يونيو",
      "يوليو",
      "أغسطس",
      "سبتمبر",
      "أكتوبر",
      "نوفمبر",
      "ديسمبر",
    ],
  };

  const month = monthNames[language][dateObj.getMonth()];
  const year = dateObj.getFullYear();

  return language === "en" ? `${month} ${year}` : `${month} ${year}`;
};

export const getWorkDurationText = (months, language = "en") => {
  if (!months || months < 0) return "";

  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;

  if (language === "en") {
    if (years === 0) {
      return `${remainingMonths} month${remainingMonths !== 1 ? "s" : ""}`;
    } else if (remainingMonths === 0) {
      return `${years} year${years !== 1 ? "s" : ""}`;
    } else {
      return `${years} year${
        years !== 1 ? "s" : ""
      } and ${remainingMonths} month${remainingMonths !== 1 ? "s" : ""}`;
    }
  } else {
    if (years === 0) {
      return `${remainingMonths} ${
        remainingMonths === 1 ? "شهر" : remainingMonths === 2 ? "شهران" : "أشهر"
      }`;
    } else if (remainingMonths === 0) {
      return `${years} ${
        years === 1 ? "سنة" : years === 2 ? "سنتان" : "سنوات"
      }`;
    } else {
      return `${years} ${
        years === 1 ? "سنة" : years === 2 ? "سنتان" : "سنوات"
      } و ${remainingMonths} ${
        remainingMonths === 1 ? "شهر" : remainingMonths === 2 ? "شهران" : "أشهر"
      }`;
    }
  }
};

export const dateToISO = (date) => {
  if (!date) return null;

  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) return null;

  return dateObj.toISOString();
};

export const parseISODate = (isoString) => {
  if (!isoString) return null;

  const date = new Date(isoString);
  return isNaN(date.getTime()) ? null : date;
};
